<template>
  <div class="container-fluid mt-5">
    <loading
      :active.sync="fullscreenLoading"
      :can-cancel="false"
      :on-cancel="onCancel"
      :is-full-page="true"
      :color="loadingColor"
      :height="loadingHeight"
      :width="loadingWidth"
    ></loading>
    <div class="row">
      <div class="col-12 text-right">
        <base-button
          @click="goBack"
          type="button"
          class="btn btn-sm btn-primary"
          >Volver</base-button
        >
      </div>
      <div class="col-xl-12 order-xl-1">
        <card>
          <div slot="header" class="row align-items-center">
            <div class="col-8">
              <h3 class="mb-0">Detalles del empleado</h3>
            </div>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-lg-3">
                <div v-if="image" class="profile-image card-img">
                  <img :src="`${image}`" class="profile-image argon-image" />
                </div>
                <div v-else class="profile-image">
                  <img
                    src="/img/placeholder.png"
                    class="argon-image"
                    width="212"
                  />
                </div>
              </div>
              <div class="col-lg-9">
                <div class="row">
                  <div class="col-lg-6">
                    <base-input
                      label="Nombre"
                      placeholder="Nombre"
                      v-model="user.nombre"
                      disabled
                    />
                  </div>
                  <div class="col-lg-6">
                    <base-input
                      label="Apellidos"
                      placeholder="Apellidos"
                      v-model="user.apellidos"
                      disabled
                    />
                  </div>
                </div>

                <div class="row">
                  <div class="col-lg-6">
                    <base-input
                      label="Email"
                      placeholder="Email"
                      v-model="user.email"
                      disabled
                    />
                  </div>
                  <div class="col-lg-6">
                    <base-input
                      label="Teléfono"
                      placeholder="Teléfono"
                      v-model="user.telefono"
                      disabled
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </card>

        <card>
          <div slot="header" class="row align-items-center">
            <div class="col-8">
              <h3 class="mb-0">Equipos para inspección</h3>
            </div>
          </div>

          <div class="card-body p-0">
            <div class="p-0">
              <div
                class="row col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
              >
                <!-- BUSCADOR:-->
                <div class="col-md-4">
                  <div>
                    <form>
                      <base-input
                        v-model="query"
                        type="search"
                        prepend-icon="fas fa-search"
                        placeholder="Buscar por marca, modelo, nº serie..."
                        clearable
                      />
                    </form>
                  </div>
                </div>
                <!-- FILTROS:-->
                <div class="col-md-8">
                  <div
                    class="d-flex justify-content-right justify-content-sm-end"
                  >
                    <div class="pr-4">
                      <el-select
                        class="select-primary pagination-select"
                        v-model="estado"
                        placeholder="Estado"
                        style="width: 100%; height: 46px !important"
                      >
                        <el-option
                          class="select-primary"
                          v-for="item in estados"
                          :key="item"
                          :label="item"
                          :value="item"
                        >
                        </el-option>
                      </el-select>
                    </div>
                    <div>
                      <div class="row">
                        <div class="col pr-1">
                          <base-input label="">
                            <flat-picker
                              slot-scope="{ focus, blur }"
                              @on-open="focus"
                              @on-close="blur"
                              :config="configInput"
                              class="form-control datepicker"
                              v-model="fdesde"
                              placeholder="Fecha inspección desde..."
                            >
                            </flat-picker>
                          </base-input>
                        </div>
                        <div class="col pl-0">
                          <base-input label="">
                            <flat-picker
                              slot-scope="{ focus, blur }"
                              @on-open="focus"
                              @on-close="blur"
                              :config="configInput"
                              class="form-control datepicker"
                              v-model="fhasta"
                              placeholder="Fecha inspección hasta..."
                            >
                            </flat-picker>
                          </base-input>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- TABLA DE EQUIPOS:-->
              <el-table
                ref="multipleTable"
                class="table-responsive align-items-center table-flush"
                header-row-class-name="thead-light"
                :data="activos"
                @sort-change="sortChange"
                @selection-change="handleSelectionChange"
                empty-text="No hay ningún elemento en esta tabla"
              >
                <!-- LOADING-->
                <div slot="empty" v-if="loadingTable">
                  <img
                    src="/img/loading.gif"
                    style="height: 100px; width: 100px"
                  />
                </div>
                <el-table-column type="selection" width="30"> </el-table-column>

                <el-table-column
                  label="Modelo"
                  prop="modelo.data.attributes.nombre"
                  sortable="custom"
                  :min-width="100"
                >
                  <template v-slot="{ row }">
                    {{ row.modelo?.data?.attributes?.nombre || '' }} - <b>{{ row.fabricante?.data?.attributes?.nombre || '' }}</b>
                  </template>
                </el-table-column>
                <el-table-column
                  label="Nº serie"
                  prop="numero_serie"
                  sortable="custom"
                  :min-width="50"
                >
                  <template v-slot="{ row }">
                    <b>{{ row.numero_serie }}</b>
                  </template>
                </el-table-column>

                <el-table-column
                  label=""
                  :min-width="24"
                  justify-content-center
                >
                  <template v-slot="{ row }">
                    <!-- RETIRADO -->
                    <div v-if="row.retirado" class="retired-icon">
                      <i
                        class="fas fa-archive"
                        style="color: #666; font-size: 18px"
                      ></i>
                      <span class="badge badge-retired no-strike"
                        >RETIRADO</span
                      >
                    </div>
                    <!-- NO APTO -->
                    <img
                      v-else-if="
                        row.revisiones?.data?.length > 0 &&
                        row.revisiones?.data?.[row.revisiones.data.length - 1]?.attributes?.estado === 'no_apto'
                      "
                      src="/img/ios-alert.png"
                      style="height: 24px; width: 24px"
                    />
                    <!-- CADUCADOS -->
                    <img
                      v-else-if="
                        moment(row.fecha_prox_revision).isBefore(
                          new Date().getTime()
                        )
                      "
                      src="/img/ios-time.png"
                      style="height: 24px; width: 24px"
                    />
                    <!--  APTO A VIGILAR -->
                    <img
                      v-else-if="
                        row.revisiones?.data?.length > 0 &&
                        row.revisiones?.data?.[row.revisiones.data.length - 1]?.attributes?.estado === 'apto_a_vigilar'
                      "
                      src="/img/ios-checkmark-orange.png"
                      style="height: 24px; width: 24px"
                    />

                    <img
                      v-else-if="
                        moment()
                          .add(3, 'months')
                          .isSameOrAfter(moment(row.fecha_prox_revision))
                      "
                      src="/img/ios-time-blue.png"
                      style="height: 24px; width: 24px"
                    />

                    <img
                      v-else-if="
                        row.revisiones?.data?.length > 0 &&
                        row.revisiones?.data?.[row.revisiones.data.length - 1]?.attributes?.estado === 'apto'
                      "
                      src="/img/ios-checkmark-circle.png"
                      style="height: 24px; width: 24px"
                    />
                    <img
                      v-else-if="
                        moment()
                          .add(3, 'months')
                          .isBefore(moment(row.fecha_prox_revision))
                      "
                      src="/img/ios-checkmark-circle.png"
                      style="height: 24px; width: 24px"
                    />
                  </template>
                </el-table-column>

                <el-table-column
                  label="Fecha Inspección"
                  prop="fecha_inspeccion"
                  sortable="custom"
                  :min-width="100"
                >
                  <template v-slot="{ row }">
                    <template v-if="row.inspecciones_visuales?.data?.length > 0">
                      <badge class="badge-dot mr-4" type="">
                        <i
                          v-if="
                            moment(obtenerUltimaFechaInspeccion(row.inspecciones_visuales.data)).isBefore(
                              moment().subtract(1, 'year')
                            )
                          "
                          class="bg-danger"
                        ></i>
                        <i
                          v-else-if="
                            moment(obtenerUltimaFechaInspeccion(row.inspecciones_visuales.data)).isBefore(
                              moment().subtract(9, 'months')
                            )
                          "
                          class="bg-warning"
                        ></i>
                        <i
                          v-else
                          class="bg-success"
                        ></i>

                        <span class="status"
                          >{{
                            moment(obtenerUltimaFechaInspeccion(row.inspecciones_visuales.data)).format("DD/MM/YYYY")
                          }}
                          ({{ moment(obtenerUltimaFechaInspeccion(row.inspecciones_visuales.data)).fromNow() }})</span
                        >
                      </badge>
                    </template>
                    <template v-else>
                      <badge class="badge-dot mr-4" type="">
                        <i class="bg-secondary"></i>
                        <span class="status">Sin inspecciones</span>
                      </badge>
                    </template>
                  </template>
                </el-table-column>

                <el-table-column
                  label="Estado inspección visual"
                  prop="estado_inspeccion_visual"
                  sortable="custom"
                  :min-width="120"
                >
                  <template v-slot="{ row }">
                    <span
                      class="badge badge-default"
                      :class="{
                        'badge-success': getEstadoInspeccionVisual(row) === 'completada',
                        'badge-danger': getEstadoInspeccionVisual(row) === 'con_incidencia',
                        'badge-warning': getEstadoInspeccionVisual(row) === 'pendiente',
                        'badge-info': getEstadoInspeccionVisual(row) === 'no_completada'
                      }"
                    >
                      {{
                        formatEstado(getEstadoInspeccionVisual(row))
                      }}
                      <i
                        v-if="inspeccionVisualMesActualResuelta(row)"
                        class="fa fa-comment ml-1"
                        title="Observaciones resueltas"
                      ></i>
                    </span>
                  </template>
                </el-table-column>

                <el-table-column label="Acciones" align="left" :min-width="40">
                  <div slot-scope="{ row }" class="table-actions">
                    <base-button
                      outline
                      size="sm"
                      type="primary"
                      @click="viewTipo(row)"
                      style="padding-left: 10px; padding-right: 10px"
                      >Ver</base-button
                    >
                  </div>
                </el-table-column>
              </el-table>
            </div>
            <div
              slot="footer"
              class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
            >
              <div class="row">
                <div class="col-xl-4">
                  <el-select
                    class="select-primary pagination-select"
                    v-model="pagination.perPage"
                    placeholder="Per page"
                  >
                    <el-option
                      class="select-primary"
                      v-for="item in pagination.perPageOptions"
                      :key="item"
                      :label="item"
                      :value="item"
                    >
                    </el-option>
                  </el-select>
                </div>

                <div class="col-xl-8">
                  <p class="card-category" style="margin-top: 0.5rem">
                    Mostrando {{ total ? from + 1 : 0 }} - {{ to }} de
                    {{ total }} registros

                    <span v-if="selectedRows.length">
                      &nbsp; &nbsp; {{ selectedRows.length }} rows selected
                    </span>
                  </p>
                </div>
              </div>

              <base-pagination
                class="pagination-no-border"
                v-model="pagination.currentPage"
                :per-page="pagination.perPage"
                :total="total"
              />
            </div>
          </div>
        </card>
      </div>
    </div>
  </div>
</template>

<script>
import formMixin from "@/mixins/form-mixin";
import BaseInput from "@/components/Inputs/BaseInput.vue";
import BaseButton from "@/components/BaseButton.vue";
import { BasePagination } from "@/components/";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import {
  Table,
  TableColumn,
  Select,
  Option,
  DropdownMenu,
  DropdownItem,
  Dropdown,
  Tooltip,
} from "element-ui";
import moment from "moment";
import "moment/locale/es";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import { Spanish } from "flatpickr/dist/l10n/es.js";
import axios from 'axios';
moment.locale("es");

export default {
  name: "view-inspeccion-visual",
  components: {
    BaseInput,
    BaseButton,
    Loading,
    BasePagination,
    flatPicker,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Select.name]: Select,
    [Option.name]: Option,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    [Dropdown.name]: Dropdown,
    [Tooltip.name]: Tooltip,
  },
  mixins: [formMixin],
  data() {
    return {
      fullscreenLoading: false,
      loadingColor: "#7f1058",
      loadingHeight: 128,
      loadingWidth: 128,
      loading: true,
      image: null,
      file: null,
      user: {
        type: "users",
        username: null,
        email: null,
        nombre: null,
        apellidos: null,
        profile_image: null,
        imagen_perfil: null,
        activo: null,
        blocked: null,
        confirmed: null,
        cif: null,
        estado_usuario: null,
        telefono: null,
        roles: [
          {
            type: "roles",
            id: null,
          },
        ],
      },
      activos: [],
      query: "",
      sort: "numero_serie",
      pagination: {
        perPage: 25,
        currentPage: 1,
        perPageOptions: [25, 50, 100],
      },
      total: 0,
      loadingTable: true,
      estado: null,
      estados: ["Apto", "No apto", "Con incidencia", "Todos"],
      fdesde: null,
      fhasta: null,
      selectedRows: [],
      multipleSelection: [],
      configInput: {
        allowInput: true,
        dateFormat: "d-m-Y",
        locale: Spanish,
      },
    };
  },
  computed: {
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
  },
  watch: {
    query: {
      handler: "getListDebounced",
      immediate: false,
    },
    fdesde: {
      handler: "getListDebounced",
      immediate: false,
    },
    fhasta: {
      handler: "getListDebounced",
      immediate: false,
    },
    estado: {
      handler: "getListDebounced",
      immediate: false,
    },
    pagination: {
      handler: "getList",
      immediate: false,
      deep: true,
    },
  },
  created() {
    if (this.$route.params.empleado) {
      this.user = this.$route.params.empleado;
      if (this.user.imagen_perfil) {
        this.image = this.user.imagen_perfil.url;
      }
    } else {
      this.getUser();
    }
    this.getList();
  },
  methods: {
    moment,
    onCancel() {
      console.log("User cancelled the loader.");
    },
    goBack() {
      this.$router.go(-1);
    },
    async getUser() {
      try {
        const id = this.$route.params.id;
        await this.$store.dispatch("users/get", id);
        this.user = this.$store.getters["users/user"];
        if (this.user.imagen_perfil) {
          this.image = this.user.imagen_perfil.url;
        }
      } catch (error) {
        this.$notify({
          type: "danger",
          message: "Oops, ha habido un error"
        });
        this.setApiValidation(error.response.data.errors);
      }
    },
    getActivosDebounced: _.debounce(function() {
      this.getActivos();
    }, 300),
    async getActivos() {
      try {
        const id = this.$route.params.id;
        const planta = localStorage.getItem("plantaSelected");
        
        const response = await axios.get(`${process.env.VUE_APP_API_BASE_URL}/api/activos`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`
          },
          params: {
            'filters[usuario][id][$eq]': id,
            'filters[empresa][id][$eq]': planta,
            'filters[numero_serie][$containsi]': this.query,
            populate: ['modelo', 'fabricante', 'inspecciones_visuales'],
            sort: this.sort,
            'pagination[pageSize]': 100
          }
        });
        
        // Transformar los datos para el formato que espera la vista
        this.activos = response.data.data
          .filter(activo => !activo.attributes.retirado)
          .map(activo => ({
            id: activo.id,
            modelo: activo.attributes.modelo,
            fabricante: activo.attributes.fabricante,
            numero_serie: activo.attributes.numero_serie,
            fecha_prox_revision: activo.attributes.fecha_prox_revision,
            inspecciones_visuales: activo.attributes.inspecciones_visuales || { data: [] },
            revisiones: activo.attributes.revisiones || { data: [] },
          }));
      } catch (error) {
        this.$notify({
          type: "danger",
          message: "Error al cargar los activos"
        });
      } finally {
        this.loading = false;
      }
    },
    calcularEstadoInspeccion(inspecciones) {
      if (!inspecciones || inspecciones.length === 0) return 'pendiente';
      
      const ultimaInspeccion = inspecciones[inspecciones.length - 1];
      return ultimaInspeccion.attributes.estado || 'pendiente';
    },
    obtenerUltimaFechaInspeccion(inspecciones) {
      if (!inspecciones || inspecciones.length === 0) return null;
      
      const ultimaInspeccion = inspecciones[inspecciones.length - 1];
      return ultimaInspeccion.attributes.createdAt;
    },
    formatEstado(estado) {
      const estados = {
        completada: "Completada",
        con_incidencia: "Observaciones",
        pendiente: "Pendiente",
        no_completada: "No Completada"
      };
      return estados[estado] || estado;
    },
    getInspeccionVisualMesActual(row) {
      const inspecciones = row?.inspecciones_visuales?.data || [];
      if (!Array.isArray(inspecciones) || inspecciones.length === 0) return null;

      const now = moment();
      const sameMonthInspections = inspecciones.filter((insp) => {
        const createdAt = insp?.attributes?.createdAt;
        return createdAt && moment(createdAt).isSame(now, "month");
      });

      if (sameMonthInspections.length === 0) return null;

      // Tomar la más reciente del mes actual
      return sameMonthInspections.reduce((latest, current) => {
        const latestDate = latest?.attributes?.createdAt;
        const currentDate = current?.attributes?.createdAt;
        if (!latestDate) return current;
        if (!currentDate) return latest;
        return moment(currentDate).isAfter(moment(latestDate)) ? current : latest;
      }, null);
    },
    getEstadoInspeccionVisual(row) {
      const inspeccionMesActual = this.getInspeccionVisualMesActual(row);
      if (!inspeccionMesActual) return "pendiente";

      const attrs = inspeccionMesActual.attributes || {};
      if (
        attrs.resultado === "apto" &&
        attrs.incidencia === false &&
        attrs.resolucion_tipo === "resuelta"
      ) {
        return "completada";
      }
      return attrs.estado || "pendiente";
    },
    inspeccionVisualMesActualResuelta(row) {
      const inspeccionMesActual = this.getInspeccionVisualMesActual(row);
      return Boolean(inspeccionMesActual?.attributes?.resolucion_tipo === "resuelta");
    },
    sortChange({ prop, order }) {
      this.sort = order === "descending" ? `-${prop}` : prop;
      this.getList();
    },
    realizarInspeccion(activo) {
      this.$router.push({
        name: "Realizar Inspeccion Visual",
        params: { 
          idEmpleado: this.$route.params.id,
          idActivo: activo.id 
        }
      });
    },
    getListDebounced: _.debounce(function () {
      this.getList();
    }, 300),
    async getList() {
      this.loadingTable = true;
      const planta = localStorage.getItem("plantaSelected");
      const id = this.user.id || this.$route.params.id;

      try {
        const params = {
          idEmpresa: planta,
          idEmpleado: id,
          search: this.query || undefined,
          sortOrder: this.sort.startsWith('-') ? 'desc' : 'asc',
          estadoRevision: this.estado === 'Apto' ? 'apto' : 
                         this.estado === 'No apto' ? 'no_apto' : 
                         this.estado === 'Con incidencia' ? 'con_incidencia' : undefined,
          includeRetired: false
        };

        console.log('Params enviados:', params);

        const response = await axios.get(`${process.env.VUE_APP_API_BASE_URL}/activos-list`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`
          },
          params
        });

        console.log('Respuesta completa:', response.data);

        // Verificar que tenemos datos válidos
        if (!response.data || !response.data.activos) {
          throw new Error('No se recibieron datos del servidor');
        }

        // Asegurarnos de que activos es un array, si no lo es, usar array vacío
        const activos = Array.isArray(response.data.activos) ? response.data.activos : [];
        console.log('Activos procesados:', activos);

        // Transformar los datos para mantener la compatibilidad con la vista
        this.activos = activos.map(activo => {
          const activoTransformado = {
            id: activo.id,
            numero_serie: activo.numero_serie || '',
            nombre: activo.nombre || '',
            descripcion: activo.descripcion || '',
            fecha_adquisicion: activo.fecha_adquisicion,
            fecha_fabricacion: activo.fecha_fabricacion,
            fecha_prox_revision: activo.fecha_prox_revision,
            numero_serie_qr: activo.numero_serie_qr,
            ubicacion: activo.ubicacion,
            retirado: activo.retirado || false,
            modelo: {
              data: {
                attributes: {
                  ...activo.modelo,
                  fabricante: activo.modelo?.fabricante || {},
                  division: activo.modelo?.division || {},
                  subtipo: activo.modelo?.subtipo || {},
                  normativa: activo.modelo?.normativa || {},
                  imagen: activo.modelo?.imagen || {}
                }
              }
            },
            fabricante: {
              data: {
                attributes: activo.modelo?.fabricante || {}
              }
            },
            inspecciones_visuales: {
              data: Array.isArray(activo.inspeccion_visuals) 
                ? activo.inspeccion_visuals.map(insp => ({
                    id: insp.id,
                    attributes: {
                      createdAt: insp.createdAt,
                      updatedAt: insp.updatedAt,
                      estado: insp.estado,
                      resultado: insp.resultado,
                      comentario: insp.comentario,
                      completada: insp.completada,
                      incidencia: insp.incidencia,
                      resolucion_tipo: insp.resolucion_tipo,
                      resolucion_comentario: insp.resolucion_comentario,
                      url_informe: insp.url_informe
                    }
                  }))
                : []
            },
            revisiones: {
              data: Array.isArray(activo.revisiones)
                ? activo.revisiones.map(rev => ({
                    id: rev.id,
                    attributes: {
                      fecha_revision: rev.fecha_revision,
                      fecha_proxima: rev.fecha_proxima,
                      createdAt: rev.createdAt,
                      updatedAt: rev.updatedAt,
                      url: rev.url,
                      observaciones: rev.observaciones,
                      estado: rev.estado,
                      active: rev.active,
                      tipo_revision: rev.tipo_revision,
                      estado_revision: rev.estado_revision,
                      certificado_revision: rev.certificado_revision
                    }
                  }))
                : []
            },
            usuario: activo.usuario || null,
            empresa: activo.empresa || null
          };
          console.log('Activo transformado:', activoTransformado);
          return activoTransformado;
        });

        console.log('Activos finales en this.activos:', this.activos);
        this.total = activos.length || 0;
        console.log('Total de activos:', this.total);

      } catch (error) {
        console.error('Error al cargar los activos:', error);
        this.$notify({
          type: "danger",
          message: "Error al cargar los activos: " + (error.message || 'Error desconocido')
        });
        // Inicializar con valores vacíos en caso de error
        this.activos = [];
        this.total = 0;
      } finally {
        this.loadingTable = false;
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
      this.selectedRows = val;
    },
    viewTipo(row) {
      this.$router.push({
        name: "View Activo",
        params: { id: row.id },
      });
    },
  }
};
</script>

<style>
.badge-success {
  background-color: #2dce89;
}
.badge-danger {
  background-color: #f5365c;
}
.badge-warning {
  background-color: #fb6340;
}
.badge-info {
  background-color: #11cdef;
}
.profile-image {
  width: 200px;
  height: 200px;
  object-fit: cover;
  border-radius: 50%;
  margin-bottom: 20px;
}
.profile-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 50%;
}
</style> 